import React, { useState, useCallback } from 'react';
import './StarRating.scss';
const Stars = props => {
  const { defaultRating, writeAReview, ratingid, getRating } = props;
  const [currentRating, setRating] = useState(defaultRating || null);
  const ratingObj = [5, 4, 3, 2, 1];
  const onInputChange = useCallback(
    evt => {
      if (writeAReview) {
        setRating(evt.target.value);
        getRating(evt.target.value);
      }
    },
    [currentRating, writeAReview]
  );

  return (
    <div className="star-rating-container">
      <div className="feedback">
        <div className={`${writeAReview && currentRating ? 'user-rating' : ''} rating`}>
          {ratingObj.map((rating, index) => (
            <React.Fragment key={index}>
              <input
                className={`rating-input-${rating}`}
                defaultChecked={defaultRating === rating}
                disabled={!writeAReview}
                id={`rating-${rating}-${ratingid}`}
                name={`rating-${ratingid}`}
                type="radio"
                value={rating}
                onChange={onInputChange}
              />
              <label
                className={!writeAReview ? 'small' : ''}
                htmlFor={`rating-${rating}-${ratingid}`}
              ></label>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Stars;
